module.exports = __webpack_public_path__ + "516c39703fdf26f832c3e64616602b64.png";